import React, { useState, useEffect, useRef } from 'react';
import { 
  useParams, 
  // useNavigate 
} from 'react-router-dom';
import { Box, CircularProgress, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import CloseIcon from '@mui/icons-material/Close';
import client from '../../client';
import { getGameBySlug } from '../../utils/sanityQueries'; // Importe a query por slug
import { Helmet } from 'react-helmet';

const Game = () => {
  const { core, slug } = useParams(); // Agora recebemos core e slug
  const [game, setGame] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const gameContainerRef = useRef(null);
  // const navigate = useNavigate();

  const handleGoBack = () => {
    window.history.back();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  // const handleClose = () => {
  //   navigate('/');
  //   window.location.reload();
  // };

  useEffect(() => {
    setIsLoading(true);
    client
      .fetch(getGameBySlug, { slug }) // Buscamos o jogo pelo slug
      .then((data) => {
        if (data && data.core === core) { // Verificamos se o core corresponde
          setGame(data);
        } else {
          setError('Jogo não encontrado para este core.');
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [slug, core]);

  useEffect(() => {
    if (game?.file?.asset?.url) {
      const container = document.getElementById('game');
      if (container) {
        const scriptsToRemove = document.querySelectorAll('script[src*="emulatorjs.org"]');
        scriptsToRemove.forEach(script => script.remove());
        const configToRemove = document.getElementById('emulator-config-script');
        if (configToRemove) {
          configToRemove.remove();
        }

        container.innerHTML = '';

        const configScript = document.createElement('script');
        configScript.type = 'text/javascript';
        configScript.id = 'emulator-config-script';
        configScript.innerHTML = `
          EJS_player = "#game";
          EJS_core = "${game.core === 'gbc' ? 'gb' : game.core}";
          EJS_gameUrl = "${game.file.asset.url}";
          EJS_pathtodata = "/data/";
          // EJS_language = "pt-BR";
          EJS_color = "#e53935";
          // EJS_biosUrl = "";
          EJS_startOnLoaded = true;
          // EJS_alignStartButton = "center";
          // EJS_startButtonName = "JOGAR";
          EJS_backgroundImage = "${game.box?.asset?.url}";
          EJS_backgroundBlur = true;
          // EJS_AdUrl = "/ad";
          // EJS_AdTimer = 15000;
          // EJS_AdSize = ["250px", "250px"];
          // EJS_Buttons = {
          //   playPause: true,
          //   restart: true,
          //   mute: true,
          //   settings: false,
          //   fullscreen: true,
          //   saveState: true,
          //   loadState: true,
          //   screenRecord: false,
          //   gamepad: true,
          //   cheat: false,
          //   volume: true,
          //   saveSavFiles: false,
          //   loadSavFiles: false,
          //   quickSave: true,
          //   quickLoad: true,
          //   screenshot: true,
          //   cacheManager: false,
          //   exitEmulation: false
          // };
        `;
        document.body.appendChild(configScript);

        const loaderScript = document.createElement('script');
        loaderScript.src = "/data/loader.js";
        document.body.appendChild(loaderScript);
      } else {
        console.warn("Element with id 'game' not found when trying to initialize emulator.");
      }
    } else if (game && !game.file?.asset?.url) {
      console.error("URL do arquivo não encontrada nos dados do jogo:", game);
      setError("URL do arquivo do jogo não encontrada.");
      setIsLoading(false);
    }
  }, [game]);

  const pageTitle = game ? `${core.toUpperCase()} - ${game?.name}` : 'Carregando Jogo...';
  const pageDescription = game ? `Jogue ${game?.name} no emulador de ${core} online!` : 'emulador';
  const siteUrl = window.location.origin + `/${core}/${slug}`; // URL específica do jogo
  const gameImage = game?.box?.asset?.url;

  console.log("Game Image URL:", gameImage); // Adicionando log para verificar a URL da imagem
  console.log("Site URL:", siteUrl); // Adicionando log para verificar a URL do site

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />

        {/* Meta tags para Open Graph (Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:type" content="website" />
        {gameImage && <meta property="og:image" content={gameImage} />}

        {/* Meta tags para Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        {gameImage && <meta name="twitter:image" content={gameImage} />}
      </Helmet>
      
      <IconButton
        color='inherit'
        onClick={handleGoBack}
        sx={{
          position: 'fixed',
          top: '8px',
          left: '8px',
          zIndex: (theme) => theme.zIndex.appBar + 1,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center', // Centraliza o emulador na tela
          alignItems: 'center',
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexGrow: 1,
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" align="center" sx={{ mt: 4 }}>
            Erro ao carregar o jogo: {error}
          </Typography>
        ) : !game ? (
          <Typography align="center" sx={{ mt: 4 }}>
            Jogo não encontrado.
          </Typography>
        ) : (
          <Box
            id="game"
            ref={gameContainerRef}
            style={{
              width: '100%',
              maxWidth: '100%',
              position: 'relative',
              // minHeight: '600px', // Altura mínima para o emulador
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default Game;